import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Input,
  Table,
  TableCaption,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Button,useDisclosure
} from "@chakra-ui/react";
import toast from 'react-hot-toast';
import * as XLSX from 'xlsx'
import KotBillPrintModal from './kotBillPrintModal';
import QuickBillPrintModal from './quickBillPrintModal';

const QuickBillData = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [printData,setPrintData]=useState([])
  const {isOpen,onOpen,onClose}=useDisclosure()

  const customerId = localStorage.getItem('customerId');
  const handlePrintModalOpen=()=>{
    onOpen()
  }

  const fetchData = async () => {
    const response = await axios.get(`https://api.hotel.tdrsoftware.in/api/getQuickBill/${customerId}`);
    setData(response.data);
    setFilteredData(response.data);
  };
 
const fetchData3 = async () => {
    try {
      const response = await axios.get(`https://api.hotel.tdrsoftware.in/api/getPrintData/${customerId}`);
      const rooms = response.data;
  
      // Map over rooms and fetch images dynamically
      const updatedRooms = await Promise.all(
        rooms.map(async (room) => {
          if (room.image) {
            const imageResponse = await axios.get(`https://api.hotel.tdrsoftware.in/get-image/${room.image}`, {
              responseType: 'blob', // Assuming image is returned as a blob
            });
  
            // Create a URL for the image blob
            room.imageUrl = URL.createObjectURL(imageResponse.data);
          } else {
            room.imageUrl = null; // Handle cases where image is missing
          }
          return room;
        })
      );
  
      console.log(updatedRooms, 'updatedRooms');
      setPrintData(updatedRooms);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
 
  const handlePayment = async (id) => {
    try {
      const response = await axios.put(`https://api.hotel.tdrsoftware.in/api/updatePayment/${customerId}/${id}`);
      alert(response.data.message);
      window.location.reload('/quickBillData');
    } catch (error) {
      toast.error(error);
    }
  };
  useEffect(() => {
    fetchData();
    fetchData3()
  }, [customerId]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    filterData(event.target.value, startDate, endDate);
  };

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
    filterData(searchTerm, event.target.value, endDate);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
    filterData(searchTerm, startDate, event.target.value);
  };

  const filterData = (term, start, end) => {
    let filtered = data.filter(order => {
      const orderDate = new Date(order.createdAt).getTime();
      const startFilter = start ? new Date(start).getTime() : null;
      const endFilter = end ? new Date(end).getTime() : null;

      if (!term && !startFilter && !endFilter) {
        return true; // No filters applied, return all data
      }

      const matchesTerm = term && (
        order.name.toLowerCase().includes(term.toLowerCase()) ||
        order.phoneNo.includes(term) // Include phone number in search
      );

      const withinDateRange = (!startFilter || orderDate >= startFilter) &&
        (!endFilter || orderDate <= endFilter);

      return matchesTerm && withinDateRange;
    });

    setFilteredData(filtered);
  };

  const handlePrint = (order) => {
    const foodItemsContent = order.foodItem.map(item => `
      <tr>
        <td>${item.name}</td>
        <td>${item.quantity}</td>
        <td>${item.price}</td>
      </tr>
    `).join('');
    const content = `
    <html>
      <head>
        <title>Quick Bill</title>
        <style>
          body { font-family: Arial, sans-serif;color:purple }
          table { width: 100%; border-collapse: collapse; }
          th, td { border: 1px solid #dddddd; text-align: left; padding: 8px; }
          th { background-color: #f2f2f2; }
        </style>
      </head>
      <body>
        <h2 style="text-align:center">Quick Bill</h2>
        <div style="display: flex; justify-content: center; align-items: center; gap:18px">
          ${printData.map((item) => `
            
              <img src="${item.imageUrl}" style="width: 200px; height: 200px;borderRadius:12px" />
              <div>
                <h1>${item.name}</h1>
                <h5>${item.adress}</h5>
                <h5>Phone:${item.phoneNo}</h5>
                <h5>Website:${item.website}</h5>
                <h5>Email id: ${item.email}</h5>
                <h5>Gst No: ${item.gstNo}</h5>
              </div>
            
          `).join('')}
        </div>
        <div style="display:flex;flex-direction:row;gap:10px;justify-content:space-evenly">
        <h4>Name-${order.name}</h4>
        <h4>Phone-${order.phoneNo}</h4>
        <h4>Status-${order.status ? "Due" : "Paid"}</h4>
        </div>
        <table>
          <thead>
            <tr>
              <th>Food Name</th>
              <th>Quantity</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            ${order.foodItem.map((foodItem) => `
              <tr>
                <td>${foodItem.name}</td>
                <td>${foodItem.quantity}</td>
                <td>${foodItem.price}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
        <table style="margin-top:10px">
          <thead>
            <tr>
            <th>BillNo</th>
              <th>Amount</th>
              <th>Taxable Amount</th>
              <th>Cgst(2.5%)</th>
              <th>Sgst(2.5%)</th>
              <th>Total</th>
              
            </tr>
          </thead>
          <tbody>
            <tr>
            <td>${order.billNo}</td>
              <td>${order.foodItem.reduce((acc,d)=>{return acc+(d.price*d.quantity)},0)}</td>
              <td>${order.foodItem.reduce((acc,d)=>{return acc+(d.price*d.quantity)},0)}</td>
              <td>${order.foodItem.reduce((acc,d)=>{return acc+(d.price*d.quantity)*0.025},0)}</td>
              <td>${order.foodItem.reduce((acc,d)=>{return acc+(d.price*d.quantity)*0.025},0)}</td>
              <td>${order.totalBilling}</td>
             
            </tr>
          </tbody>
        </table>
        <script>
          window.onload = () => window.print();
        </script>
      </body>
    </html>
    `;
    

    const printWindow = window.open('', '', 'height=600,width=800');
    printWindow.document.open();
    printWindow.document.write(content);
    printWindow.document.close();
  };
  const exportToExcel = () => {
    // Filter out _id and createdAt fields from the data
    const cleanedData = filteredData.map(({ _id, createdAt, ...rest }) => rest);
  
    // Create a worksheet from the cleaned data
    const worksheet = XLSX.utils.json_to_sheet(cleanedData);
  
    // Capitalize the first letter of each header
    const headers = Object.keys(cleanedData[0] || {});
    headers.forEach((header, index) => {
      const cellAddress = XLSX.utils.encode_cell({ c: index, r: 0 });
      worksheet[cellAddress].v = header.charAt(0).toUpperCase() + header.slice(1);
    });
  
    // Calculate totals for cash and online columns
    let totalCash = 0;
    let totalOnline = 0;
    
    cleanedData.forEach((row) => {
      totalCash += parseInt(row.cash) || 0;
      totalOnline += parseInt(row.online) || 0;
    });
  
    // Add the totals row
    const totalRow = {
      cash: totalCash,
      online: totalOnline,
      // Add any other columns you want to include in the totals row
    };
    
    // Append the total row to the worksheet
    XLSX.utils.sheet_add_json(worksheet, [totalRow], { skipHeader: true, origin: -1 });
  
    // Add borders to all cells in the worksheet
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = { c: C, r: R };
        const cellRef = XLSX.utils.encode_cell(cellAddress);
  
        if (!worksheet[cellRef]) continue;
        if (!worksheet[cellRef].s) worksheet[cellRef].s = {};
        
        worksheet[cellRef].s.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
      }
    }
  
    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Cash Data');
  
    // Write the workbook to an Excel file
    XLSX.writeFile(workbook, 'QuickFoodBillData.xlsx');
  };

  

  return (
    <Box>
      <Box mb={4} display="flex" justifyContent="space-between">
        <Input
          w='40%'
          type="text"
          placeholder="Search by Name or Phone"
          value={searchTerm}
          onChange={handleSearchChange}
        />
        <Input
          w='20%'
          type="date"
          placeholder="Start Date"
          value={startDate}
          onChange={handleStartDateChange}
          mr={2}
        />
        <Input
          w='20%'
          type="date"
          placeholder="End Date"
          value={endDate}
          onChange={handleEndDateChange}
          mr={2}
        />
       
      </Box>
      <Button colorScheme="blue" onClick={exportToExcel} p={2} mb={5}>
       Export to Excel File
      </Button>
       <Button colorScheme="blue" onClick={handlePrintModalOpen} p={2} ml={2} mb={5}>Print</Button>
       <QuickBillPrintModal customerId={customerId} isOpen={isOpen} onOpen={onOpen} onClose={onClose} foodBillData={filteredData}/>
      <TableContainer width='full'>
        <Table size='sm' variant='striped' colorScheme='green'>
          <TableCaption>Quick Bill Data</TableCaption>
          <Thead>
            <Tr>
              <Th>Food Item</Th>
              <Th>Name</Th>
              <Th>Phone No</Th>
              <Th>Bill No</Th>
              <Th>Total Bill</Th>
              <Th>Status</Th>
              <Th>Paid</Th>
              <Th>Created At</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {filteredData.map((order, index) => (
              <Tr key={index}>
                <Td>{order.foodItem.map(item => item.name).join(', ')}</Td>
                <Td>{order.name}</Td>
                <Td>{order.phoneNo}</Td>
                <Td>{order.billNo}</Td>
                <Td>{order.totalBilling}</Td>
                <Td>{order.status ? "Due" : "Paid"}</Td>
                <Td onClick={()=>handlePayment(order._id)}> <Button colorScheme='green'  onClick={()=>handlePayment(order._id)}>Change</Button></Td>
                <Td>{new Date(order.createdAt).toLocaleString('en-GB')}</Td>
                <Td>
                  <Button colorScheme="blue" size="sm" onClick={() => handlePrint(order)}>Print</Button>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default QuickBillData;
